import styled from 'styled-components';
import { propStyles } from '../styleHelper';
import styleFilter from '../styleFilter';

const Form = styled(styleFilter(styled.form``))`
  ${propStyles}
`;

export default Form;
